import Vue from 'vue';
import { ActionTree, MutationTree } from 'vuex';
import { RootState } from '@/store/types';
import { ServerResult } from '@/core/http/server_result';
import moment from 'moment';
// import moment from 'moment';

interface WorkPlanBoardState {
    loaded: boolean;
    loading: boolean;
    fatalError: boolean;

    document: any;
    form: any;
    schema: any;

    allRoles: any[];
    grants: any[];
    // selectedRoles: any[];
}

const state: WorkPlanBoardState = {
    loading: false,
    loaded: false,
    fatalError: false,

    document: null,
    form: null,
    schema: null,

    allRoles: [],
    grants: [],
};

const initState = JSON.parse(JSON.stringify(state));

export const EMPLOYEE_DATA = 'GET_EMPLOYEE_DATA';
export const EMPLOYEE_SCHEMA = 'GET_EMPLOYEE_SCHEMA';
export const SELECT_ROLES_OP = 'SELECT_ROLES_OP';
export const SELECT_GRANTS_OP = 'SELECT_GRANTS_OP';

export const actions: ActionTree<WorkPlanBoardState, RootState> = {
    reset({ commit }) {
        commit('RESET_STATE')
    },

    init({ commit, dispatch }, params) {
        return dispatch('loadData', params);
    },

    loadData({ commit, getters, dispatch }, params) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(EMPLOYEE_DATA)
                    .raw('documents.get')
                    .action({
                        id: params.id
                    }),
                vm.$q(SELECT_ROLES_OP)
                    .raw('documents.list')
                    .action({
                        columns: {
                            id: 'role.id',
                            code: 'role.code',
                            name: 'role.name'
                        },

                        from: 's:access_roles',
                        from_as: 'role',
                        order: [
                            {$asc: ['role.name']}
                        ]
                    }),
                  vm.$q(SELECT_GRANTS_OP)
                    .raw('documents.list')
                    .action({
                        columns: {
                            id: 'grantisimo.id',
                            role_id: 'grantisimo.role_id',
                            actor_id: 'grantisimo.actor_id'
                        },

                        from: 's:access_role_grants',
                        from_as: 'grantisimo',
                        where: {
                            $eq: [`grantisimo.actor_id`, {$: params.id}]
                        }
                    }),
            ]).then((result: ServerResult) => {
                commit('SET_FORM_DATA', {
                    document: result.getOperation(EMPLOYEE_DATA).getContent(),
                    allRoles: result.getOperation(SELECT_ROLES_OP).getContent(),
                    grants: result.getOperation(SELECT_GRANTS_OP).getContent(),
                });

                commit('LOADED_SUCCESS');
                resolve();
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    prepareNew({ commit, state }) {
        const vm = (this as any)._vm;

        return new Promise((resolve, reject) => {
            commit('START_LOADING');

            vm.$db([
                vm.$q(EMPLOYEE_SCHEMA)
                    .raw('schemas.get')
                    .action({
                        id: `s:employees`
                    }),
                vm.$q(SELECT_ROLES_OP)
                    .raw('documents.list')
                    .action({
                        columns: {
                            id: 'role.id',
                            code: 'role.code',
                            name: 'role.name'
                        },

                        from: 's:access_roles',
                        from_as: 'role',
                        order: [
                            {$asc: ['role.name']}
                        ]
                    }),
            ]).then((result: ServerResult) => {
                commit('GENERATE_FORM_DATA', {
                    schema: result.getOperation(EMPLOYEE_SCHEMA).getContent(),
                    allRoles: result.getOperation(SELECT_ROLES_OP).getContent(),
                });

                commit('LOADED_SUCCESS');
                resolve();
            })
            .catch((error: any) => {
                console.log('error', error)
                commit('LOADED_ERROR');
                reject()
            })
        })
    },

    toggleCredentials({commit}) {
        commit('TOGGLE_CREDS');
    },

    toggleRoleSelection({commit}, roleID) {
        commit('TOGGLE_ROLE', roleID);
    },

    changeFormValue({commit}, {field, newValue}) {
        commit('CHANGE_VALUE', {field, newValue});
    },
    changeCredentialsValue({commit}, {field, newValue}) {
        commit('CHANGE_CREDS_VALUE', {field, newValue});
    },

    saveForm({ commit, getters, dispatch }, params) {
        const vm = (this as any)._vm;

        const normalizedForm = state.schema.fields.reduce((prev: any, field: any) => {
            const fieldName = field.code;

            if (state.form[fieldName]) {
                switch(field.type) {
                    case 'date': {
                        prev[fieldName] = moment(state.form[fieldName]).utc().local().format('YYYY-MM-DD');
                        break;
                    }
                    case 'credentials': {
                        prev[fieldName] = {
                            login: state.form[fieldName].login,
                            password: state.form[fieldName].password ? state.form[fieldName].password : ''
                        };
                        break;
                    }
                    default: {
                        prev[fieldName] = state.form[fieldName]
                    }
                }

            }

            return prev
        }, {});

        if (normalizedForm.credentials && !normalizedForm.credentials.password) {
            delete normalizedForm.credentials;
        }

        console.log('normalizedForm', normalizedForm);

        return new Promise((resolve, reject) => {
            commit('START_LOADING');
            console.log('1')
            let saveQuery = null;
            console.log('2')
            if (params.id) {
                saveQuery = vm.$q('EMPLOYEE_DATA_SAVE')
                    .update(params.id, normalizedForm)
                    .createManyRelation('access_role_grants', 'actor_id', (createRelated: Function) => {
                        return state.form.roles.filter((roleId: any) => !state.grants.map((grant: any) => grant.role_id).includes(roleId))
                            .map((item: any, index: number) => createRelated({ role_id: item}));
                    })
                    .deleteManyRelation('access_role_grants', 'actor_id', (deleteRelated: Function) => {
                        return state.grants.filter((grant: any) => !state.form.roles.includes(grant.role_id))
                            .map((item: any, index: number) => deleteRelated(item));
                    })
            } else {
                saveQuery = vm.$q('EMPLOYEE_DATA_SAVE')
                    .create('s:employees', normalizedForm)
                    .withManyRelation('access_role_grants', 'actor_id', (createRelated: Function) => {
                        return state.form.roles.filter((roleId: any) => !state.grants.map((grant: any) => grant.role_id).includes(roleId))
                            .map((item: any, index: number) => createRelated({ role_id: item}));
                    })
            }
            console.log('3')
            console.log('saveQuery', saveQuery)

            vm.$db([
                saveQuery
            ]).then((result: ServerResult) => {
                const operationResult = result.getOperation('EMPLOYEE_DATA_SAVE');
                console.log('4')
                if (operationResult.hasError()) {
                    console.log('error', operationResult.getContent());

                    commit('LOADED_SUCCESS');
                    reject();
                } else {
                    commit('ON_FORM_SAVE', { document: operationResult.getContent(), savedGrants: state.form.roles})

                    // create_related
                    //     s:access_role_grants/actor_id
                    //         documents
                    commit('LOADED_SUCCESS');
                    resolve(operationResult.getContent());
                }
            })
            .catch((error: any) => {
                console.log('errror', error)
            });
        })
    },
};

export const mutations: MutationTree<WorkPlanBoardState> = {
    RESET_STATE: (state) => {
        for(const key in initState) {
            (state as any)[key] = initState[key]
        }
    },
    START_LOADING: (state) => {
        state.loaded = false;
        state.loading = true;
        state.fatalError = false;
    },
    LOADED_SUCCESS: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = false;
    },
    LOADED_ERROR: (state) => {
        state.loaded = true;
        state.loading = false;
        state.fatalError = true;
    },

    SET_FORM_DATA(state, {document, allRoles, grants}) {
        state.document = document.document;
        state.schema = document.schema;
        state.allRoles = allRoles.documents;
        state.grants = grants.documents;

        // grants
        const formData = JSON.parse(JSON.stringify(state.document))
        if(formData.birthday) {
            formData.birthday = moment(formData.birthday).toDate();
        }
        if(formData.works_since) {
            formData.works_since = moment(formData.works_since).toDate();
        }
        if (formData.credentials) {
            formData.credentials = {
                ...formData.credentials,
                password: null,
                repeatPassword: null,
            }
        }
        formData.roles = state.grants.map((grant: any) => grant.role_id);

        state.form = formData;
    },

    GENERATE_FORM_DATA(state, {schema, allRoles}) {
        state.document = {};
        state.schema = schema.schema;
        state.allRoles = allRoles.documents;
        state.grants = [];

        const formData = state.schema.fields.reduce((prev: any, field: any) => {
            prev[field.code] = null;
            return prev;
        }, {})
        formData.roles = [];

        state.form = formData;
    },

    ON_FORM_SAVE(state, {document, savedGrants}) {
        state.document = document.document;
        state.schema = document.schema;
        // state.allRoles = allRoles.documents;
        // state.grants = grants.documents;

        const formData = JSON.parse(JSON.stringify(state.document))
        formData.birthday = moment(formData.birthday).toDate();
        formData.works_since = moment(formData.works_since).toDate();
        if (formData.credentials) {
            formData.credentials = {
                ...formData.credentials,
                password: null,
                repeatPassword: null,
            }
        }
        formData.roles = savedGrants;

        state.form = formData;
    },

    CHANGE_VALUE(state: WorkPlanBoardState, {field, newValue}) {
        switch (field) {
            default:
                state.form[field] = newValue;
        }
    },
    TOGGLE_CREDS(state: WorkPlanBoardState) {
        if (state.form.credentials) {
            state.form.credentials = null
        } else {
            if (state.document.credentials) {
                state.form.credentials = {
                    ...state.document.credentials,
                    password: null,
                    repeatPassword: null,
                }
            } else {
                state.form.credentials = {
                    login: null,
                    password: null,
                    repeatPassword: null,
                }
            }
        }
    },
    TOGGLE_ROLE(state: WorkPlanBoardState, roleId) {
        if (state.form.roles.includes(roleId)) {
            state.form.roles = state.form.roles.filter((role: any) => role != roleId);
        } else {
            state.form.roles = [
                ...state.form.roles,
                roleId
            ]
        }
    },
    CHANGE_CREDS_VALUE(state: WorkPlanBoardState, {field, newValue}) {
        state.form.credentials[field] = newValue;
    },
};

const getters = {
    fields: (state: WorkPlanBoardState) => {
        return state.schema.fields.reduce((prev: any, field: any) => {
            prev[field.code] = field;
            return prev;
        }, {});
    },
};

export const STORE_KEY = '$_employee_details_form';

export const store = {
    namespaced: true,
    state,
    actions,
    getters,
    mutations,
};
